import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { UserInfoResolverService } from './core/user-info-resolver.service';
import { ContentComponent } from './content.component';
import { ErrorPageComponent } from 'account/error-page.component';
import { TenantSettingsResolverService } from 'core/tenant-settings-resolver.service';
import { NoAccessPage, NotFoundPage, AboutPage } from './pages';
import { AdministrationRole, Role } from 'api/enums';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  { path: 'error', component: ErrorPageComponent },
  {
    path: '',
    component: ContentComponent,
    canActivate: [MsalGuard],
    resolve: {
      userInfo: UserInfoResolverService,
      tenantSettings: TenantSettingsResolverService
    },
    children: [
      { path: '', redirectTo: 'cases', pathMatch: 'full' },
      { path: 'about', component: AboutPage },

      {
        path: 'cases',
        loadChildren: () =>
          import('./cases/cases.module').then(m => m.CasesModule),
        canActivate: [MsalGuard],
        data: {
          userRoles: Role.CaseManager | Role.FirstLine | Role.Customer
        }
      },
      {
        path: 'warehouse',
        loadChildren: () =>
          import('./warehouse/warehouse.module').then(m => m.WarehouseModule),
        canActivate: [MsalGuard],
        data: {
          userRoles: Role.CaseManager
        }
      },

      {
        path: 'tw',
        loadChildren: () =>
          import(
            './transactional-warehouse/transactional-warehouse.module'
          ).then(m => m.TransactionalWarehouseModule),
        canActivate: [MsalGuard],
        data: {
          userRoles: Role.CaseManager
        }
      },

      {
        path: 'orders',
        loadChildren: () =>
          import('./orders/orders.module').then(m => m.OrdersModule),
        canActivate: [MsalGuard],
        data: {
          userRoles: Role.CaseManager | Role.FirstLine | Role.Customer
        }
      },

      {
        path: 'ocr',
        loadChildren: () => import('./ocr/ocr.module').then(m => m.OcrModule),
        canActivate: [MsalGuard],
        data: {
          userRoles: Role.CaseManager
        }
      },

      {
        path: 'financials',
        loadChildren: () =>
          import('./financials/financials-routing.module').then(
            m => m.FinancialsRoutingModule
          ),
        canActivate: [MsalGuard],
        data: {
          userRoles: Role.CaseManager,
          adminRoles: AdministrationRole.FinancialsAdministration
        }
      },

      {
        path: 'admin',
        loadChildren: () =>
          import('./admin/admin-routing.module').then(
            m => m.AdminRoutingModule
          ),
        canActivate: [MsalGuard],
        data: {
          adminRoles: AdministrationRole.All
        }
      },

      {
        path: 'account',
        loadChildren: () =>
          import('./account/account-routing.module').then(
            m => m.AccountRoutingModule
          ),
        canActivate: [MsalGuard],
        data: {
          userRoles: Role.CaseManager | Role.Customer
        }
      },
      {
        path: 'integrations',
        loadChildren: () =>
          import('./integrations/integrations-routing.module').then(
            m => m.IntegrationsRoutingModule
          )
      },

      { path: 'no-access', component: NoAccessPage },
      { path: 'not-found', component: NotFoundPage },
      { path: '**', redirectTo: '/not-found' }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
